import 'angular-local-storage';
import 'angular-mocks';

import focusOnVisibility from './focusOnVisibility';
import './styles/index.scss';
import calendarAttendance from './calendarAttendance';
import fixedHeader from './fixedHeader';

let namespace = angular.module('olr-directives', [
  "LocalStorageModule"
]);

namespace.directive('focusOnVisibility', focusOnVisibility);
namespace.directive('calendarAttendance', calendarAttendance);
namespace.directive('fixedHeader', fixedHeader);

export default namespace.name;





/** WEBPACK FOOTER **
 ** ./src/olr-directives/index.js
 **/